import axios from "axios";
import { toast } from "react-toastify";
const baseUrl = process.env.REACT_APP_BASE_URL;

export const UPDATE_HOMEPAGE_VIDEO_REQUEST = "UPDATE_HOMEPAGE_VIDEO_REQUEST";
export const UPDATE_HOMEPAGE_VIDEO_SUCCESS = "UPDATE_HOMEPAGE_VIDEO_SUCCESS";
export const UPDATE_HOMEPAGE_VIDEO_FAILURE = "UPDATE_HOMEPAGE_VIDEO_FAILURE";

export const LIST_HOMEPAGE_VIDEO_REQUEST = "LIST_HOMEPAGE_VIDEO_REQUEST";
export const LIST_HOMEPAGE_VIDEO_SUCCESS = "LIST_HOMEPAGE_VIDEO_SUCCESS";
export const LIST_HOMEPAGE_VIDEO_FAILURE = "LIST_HOMEPAGE_VIDEO_FAILURE";

export const updateHomepageVideo = (data, setProgress) => {
    return async (dispatch) => {
        try {
            let icon = "";
            if (data && data.icon && data.icon.file) {
                const imgRes = await axios.post(
                    `${process.env.REACT_APP_BASE_URL}/s3/upload/home/page/video/v1`,
                    {
                        sFileName: data.icon.file.name,
                        sContentType: data.icon.file.type
                    },
                    {
                        headers: {
                            Authorization: localStorage.getItem("token")
                        }
                    }
                );
                
                const imageUrl = imgRes.data.data.sUrl;
                icon = imgRes.data.data.sPath;
                
                await axios.put(
                    imageUrl,
                    data.icon.file,
                    {
                        headers: { 
                            "Content-Type": data.icon.file.type 
                        },
                        onUploadProgress: (progressEvent) => {
                            const percentCompleted = Math.round(
                                (progressEvent.loaded * 100) / progressEvent.total
                            );
                            // console.log(percentCompleted, 'percentCompleted')
                            setProgress(percentCompleted);
                        }
                    }
                );
            }

            dispatch({ type: UPDATE_HOMEPAGE_VIDEO_REQUEST });

            const updatedUrlWeb = icon === "" ? data.url : `https://asset.yaadein.co/${icon}`;
            const url = `${baseUrl}/home/page/video/update/${data._id}/v1`;
            
            const response = await axios.post(
                url,
                { ...data, url: updatedUrlWeb },
                {
                    headers: {
                        Authorization: localStorage.getItem("token")
                    }
                }
            );

            dispatch({ type: UPDATE_HOMEPAGE_VIDEO_SUCCESS, payload: response.data });
            toast("Homepage Video is updated successfully.");
            
            dispatch(listHomepageVideo());
            
        } catch (error) {
            console.error(error);
            dispatch({ type: UPDATE_HOMEPAGE_VIDEO_FAILURE, payload: error.message });
            toast(error?.response?.data?.message);
        }
    };
};
export const listHomepageVideo = () => {
    return async (dispatch) => {
        dispatch({ type: LIST_HOMEPAGE_VIDEO_REQUEST });
        try {
            const url = `${baseUrl}/home/page/video/details/v1`;
            const response = await axios.get(url, {
                headers: {
                    Authorization: localStorage.getItem("token")
                }
            });
            dispatch({ type: LIST_HOMEPAGE_VIDEO_SUCCESS, payload: response.data });
        } catch (error) {
            console.error(error);
            dispatch({ type: LIST_HOMEPAGE_VIDEO_FAILURE, payload: error.message });
        }
    }
}           

